/** Tiny DOM builders shared by the Shows screens (one copy, not one per file). */
import { iconEl, type IconName } from "../components/icons";
import { humanErrorText } from "../errors/human-error";

export function el<K extends keyof HTMLElementTagNameMap>(tag: K, className?: string, text?: string): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

/** A button with an icon and a visible label, like every other button in the product. */
export function iconButton(icon: IconName, label: string, opts: { id?: string; className?: string } = {}): HTMLButtonElement {
  const b = el("button", opts.className);
  b.type = "button";
  if (opts.id) b.id = opts.id;
  b.append(iconEl(icon), el("span", undefined, label));
  return b;
}

/** `api error` -> the sentence a person reads; never `[object Object]`, never the server's raw body (SCRUM-965: `errors/human-error.ts`). */
export function errorText(err: unknown): string {
  return humanErrorText(err);
}
